import SelectInput from 'components/input-field/SelectInput';
import TextInput from 'components/input-field/TextInput'
import { Form, Formik } from 'formik';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Col, Row } from 'reactstrap';
import Loader from 'components/loader/Loader';
import FileInput from 'components/input-field/FileInput';
import SaveButton from 'components/buttons/SaveButton';
import { AddPathologyRes, AddPathologyTodo } from 'redux/slice/super-admin/pathology/AddPathology';
import EmailInput from 'components/input-field/EmailInput';
import Password from 'components/input-field/Password';
import UniqCodeInput from 'components/input-field/UniqCodeInput';
import { departmentListRes, departmentListTodo } from 'redux/slice/super-admin/master/department/DepartmentList';
import { DesignationListRes, DesignationListTodo } from 'redux/slice/super-admin/master/designation/DesignationList';
import { debounce } from 'lodash';
import { CityListRes, CityListTodo } from 'redux/slice/super-admin/city/CityList';
import { PathologySchema, UpdatePathologySchema } from './Validation';
import { UpdatePathologyRes, UpdatePathologyTodo } from 'redux/slice/super-admin/pathology/UpdatePathology';

class UpdatePathologyForm extends Component {
    constructor(props) {
        super(props);
        const pathologyDetails = this.props?.location?.state?.state;

        console.log(pathologyDetails)

        this.state = {
            spiner: false,
            formSpiner: false,
            cityLoading: false,
            values: {
                id: pathologyDetails.id || '',
                company_name: pathologyDetails.company_name || '',
                cust_code: pathologyDetails.cust_code || '',
                contact_person: pathologyDetails.contact_person || '',
                phone_no: pathologyDetails.phone_no || '',
                email_id: pathologyDetails.email_id || '',
                city: pathologyDetails?.city_name?.id || '',
                designation: pathologyDetails?.des_name?.id || '',
                department: pathologyDetails?.dept_name?.id || '',
                status: pathologyDetails.status || '',
                cust_logo: pathologyDetails.cust_logo || '',
            }
        };
        this.load_city = debounce(this.load_city.bind(this), 500);
    }
    

    load_city = (e) => {
        if (e) {
            this.setState({ cityLoading: true });
            this.props.dispatch(CityListTodo(e)).then(() => this.city_res());
        }
    };

    city_res = () => {
        if (CityListRes?.success) {
            this.setState({ cityLoading: false });
        } else {
            this.setState({ cityLoading: false });
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ spiner: true });
        dispatch(departmentListTodo()).then(() => this.list_res());
    }

    list_res = () => {
        if (departmentListRes?.success) {
            const { dispatch } = this.props;
            dispatch(DesignationListTodo()).then(() => this.list2_res());
        } else {
            this.setState({ spiner: false });
        }
    }
    list2_res = () => {
        if (DesignationListRes?.success) {

            this.setState({ cityLoading: true });
            this.setState({ spiner: false });
            this.props.dispatch(CityListTodo(this.props?.location?.state?.state?.city_name?.city)).then(() => this.city_res())
        } else {
            this.setState({ spiner: false });
        }
    }


    handleSubmit = (values) => {
        this.setState({ formSpiner: true });
        const { dispatch } = this.props;

        let bodyFormData = new FormData();

        bodyFormData.append("company_name", values.company_name)
        // bodyFormData.append("cust_code", values.cust_code)
        bodyFormData.append("contact_person", values.contact_person)
        bodyFormData.append("phone_no", values.phone_no)
        bodyFormData.append("email_id", values.email_id)
        bodyFormData.append("city", values.city)
        bodyFormData.append("designation", values.designation)
        bodyFormData.append("department", values.department)
        bodyFormData.append("status", values.status)
        bodyFormData.append("path", "category")
        bodyFormData.append("cust_logo", values.cust_logo)
        bodyFormData.append("modified_by", localStorage.getItem('user_id'))
        // bodyFormData.append("user_type", '1')

        dispatch(UpdatePathologyTodo({ 'data': bodyFormData, "id": values?.id })).then(() => this.add_res());

    }


    add_res = () => {
        if (UpdatePathologyRes?.success) {
            toast.success(UpdatePathologyRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                this.props.history.push('/superadmin/pathology-list');
            }, 1500);
            this.setState({ formSpiner: false });
        } else {
            toast.error(UpdatePathologyRes?.message, { position: "bottom-right" });
            this.setState({ formSpiner: false });
        }
    }
    render() {
        const { departmentList, designationList, cityList } = this.props;
        const { cityLoading } = this.state;

        const DepartmentOption = departmentList && departmentList.map(val => (
            { "value": val.id, "label": val.name }
        ))
        const DesignationOption = designationList && designationList.map(val => (
            { "value": val.id, "label": val.name }
        ))

        const city_option = cityList && cityList.map(val => (
            { "value": val.id, "label": val.city }
        ));

        const status_option = [
            { "value": 'Active', "label": "Active" },
            { "value": 'Inactive', "label": "Inactive" }
        ]

        return (
            <>
                <div className='form_layout'>
                    {this.state.spiner || this.state.formSpiner ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :

                        <Formik
                            initialValues={this.state.values}
                            validationSchema={UpdatePathologySchema}
                            onSubmit={this.handleSubmit}
                        >
                            {({
                                values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <Form>
                                    <Row>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Company Name'
                                                placeholder=''
                                                name='company_name'
                                                value={values.company_name || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.company_name && touched.company_name ? (<span className='text-danger form_label' >{errors.company_name}</span>) : null}
                                            />
                                        </Col>
                                        {/* <Col>
                                            <UniqCodeInput
                                                label_name="Unique Short Code"
                                                placeholder=''
                                                name='cust_code'
                                                value={values.cust_code || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.cust_code && touched.cust_code ? (<span className='text-danger form_label' >{errors.cust_code}</span>) : null}
                                            />

                                        </Col> */}
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Administrative'
                                                placeholder=''
                                                name='contact_person'
                                                value={values.contact_person || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.contact_person && touched.contact_person ? (<span className='text-danger form_label' >{errors.contact_person}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <TextInput
                                                label_name='Administrative Number'
                                                placeholder=''
                                                name='phone_no'
                                                value={values.phone_no || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.phone_no && touched.phone_no ? (<span className='text-danger form_label' >{errors.phone_no}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <EmailInput
                                                label_name='Email'
                                                placeholder=''
                                                name='email_id'
                                                value={values.email_id || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email_id && touched.email_id ? (<span className='text-danger form_label' >{errors.email_id}</span>) : null}
                                            />
                                        </Col>
                                        {/* <Col xl='4'>
                                            <Password
                                                label_name='Password'
                                                placeholder=''
                                                name='password'
                                                value={values.password || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.password && touched.password ? (<span className='text-danger form_label' >{errors.password}</span>) : null}
                                            />
                                        </Col> */}

                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Department'
                                                disabled={false}
                                                options={DepartmentOption}
                                                name='department'
                                                defaultValue={DepartmentOption?.find((option) => option.value === values.department)}
                                                onChange={(e) =>
                                                    setFieldValue('department', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.department && touched.department ? (<span className='text-danger form_label' >{errors.department}</span>) : null} />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Designation'
                                                disabled={false}
                                                options={DesignationOption}
                                                name='designation'
                                                defaultValue={DesignationOption?.find((option) => option.value === values.designation)}
                                                onChange={(e) =>
                                                    setFieldValue('designation', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.designation && touched.designation ? (<span className='text-danger form_label' >{errors.designation}</span>) : null} />
                                        </Col>
                                        <Col xl='4'>
                                            <FileInput
                                                name='cust_logo'
                                                label_name={'Pathology Logo'}
                                                onBlur={handleBlur}
                                                onChange={(e) => setFieldValue("cust_logo", e.currentTarget.files[0])}
                                                error={errors.cust_logo && touched.cust_logo ? (<span className='text-danger form_label' >{errors.cust_logo}</span>) : null}
                                            />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='City'
                                                disabled={false}
                                                options={city_option}
                                                name='city'
                                                defaultValue={city_option?.find((option) => option.value === values.city)}
                                                onChange={(e) =>
                                                    setFieldValue('city', e.value)
                                                }
                                                onInputChange={(e) => this.load_city(e)}
                                                loading={cityLoading}
                                                onBlur={handleBlur}
                                                error={errors.city && touched.city ? (<span className='text-danger form_label' >{errors.city}</span>) : null} />
                                        </Col>
                                        <Col xl='4'>
                                            <SelectInput
                                                closeMenu={true}
                                                label_name='Status'
                                                disabled={false}
                                                options={status_option}
                                                name='status'
                                                defaultValue={status_option?.find((option) => option.value === values.status)}
                                                onChange={(e) =>
                                                    setFieldValue('status', e.value)
                                                }
                                                onBlur={handleBlur}
                                                error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null} />
                                        </Col>

                                        <Col xl='12' className='d-flex justify-content-end'>
                                            <SaveButton name={'UPDATE'} />
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </Formik>
                    }
                </div>
                <ToastContainer />
            </>
        )
    }
}
const mapStateToProps = state => ({
    departmentList: state?.DepartmentList?.data?.data,
    designationList: state?.DesignationList?.data?.data,
    cityList: state.CityList?.data?.data || [],
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});
export default connect(mapStateToProps)(withRouter(UpdatePathologyForm));
